import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const nameMap: Record<string, string> = {
  '': '首页',
  'category': '分类',
  'article': '文章',
  'about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  const breadcrumbs: { label: string; path: string }[] = [
    { label: '首页', path: '/' },
  ];

  let currentPath = '';
  segments.forEach((seg, idx) => {
    currentPath += `/${seg}`;
    let label: string;

    if (segments[0] === 'category' && idx === 1) {
      const cat = categories.find((c) => c.slug === seg);
      label = cat ? cat.name : seg;
    } else if (segments[0] === 'article' && idx === 1) {
      label = '文章详情';
    } else {
      label = nameMap[seg] || seg;
    }

    breadcrumbs.push({ label, path: currentPath });
  });

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm" itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbs.map((crumb, idx) => (
          <li key={crumb.path} className="flex items-center gap-1" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            {idx > 0 && <span className="text-foreground-300 mx-1">/</span>}
            {idx < breadcrumbs.length - 1 ? (
              <Link to={crumb.path} className="text-foreground-500 hover:text-primary-600 transition-colors" itemProp="item">
                <span itemProp="name">{crumb.label}</span>
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium" itemProp="name">{crumb.label}</span>
            )}
            <meta itemProp="position" content={String(idx + 1)} />
          </li>
        ))}
      </ol>
    </nav>
  );
}